<template>
  <div>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3" v-if="retributionsAnalytics?.totalManagerAmount > 0">
      <div class="bg-white px-6 py-4 rounded-lg border border-gray-200">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
              <span class="text-xl">👤</span>
            </div>
            <h4 class="text-xl font-bold tracking-tight text-black">Primes vendeurs</h4>
          </div>
          <span class="text-xl font-bold text-purple-600">
            {{ formatPrice(retributionsAnalytics.totalSellerAmount) }}
          </span>
        </div>
      </div>

      <div class="bg-white px-6 py-4 rounded-lg border border-gray-200">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
              <span class="text-xl">🏢</span>
            </div>
            <h4 class="text-xl font-bold tracking-tight text-black">Primes management</h4>
          </div>
          <span class="text-xl font-bold text-purple-600">
            {{ formatPrice(retributionsAnalytics.totalManagerAmount) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPrice } from "@estaly/ui";

export default {
  name: "ManagementRetributionView",

  props: {
    retributionsAnalytics: {
      type: Object,
      required: true,
    },
  },

  methods: {
    formatPrice,
  },
};
</script>
